import { Box, Button, Card, Icon, Popover } from '@palmetto/palmetto-components';
import { useOpenClose } from '@palmetto/palmetto-components';
import { ReactNode } from 'react';

import { Flag as FlagType, RequirementFlagSettingsType } from 'types';

interface FlagActionsPopoverProps {
  children: ReactNode;
  flags: FlagType[];
  dataKey: string;
  flagType?: RequirementFlagSettingsType;
  fileName?: string;
  baseCategory?: string;
  type?: string;
  setting?: any;
  onAddFlag: () => void;
  onEditFlag: (flag: FlagType) => void;
  shouldHide: boolean;
}

export const FlagActionsPopover = ({
  children,
  flags,
  dataKey,
  setting,
  onAddFlag,
  onEditFlag,
  shouldHide,
}: FlagActionsPopoverProps) => {
  const { isOpen: isPopoverOpen, handleClose: closePopover, handleToggle: togglePopover } = useOpenClose();

  const handleButtonClick = () => {
    togglePopover();
  };

  const handleAddNewFlagClick = () => {
    closePopover();
    onAddFlag();
  };

  const handleEditFlagClick = (flag: FlagType) => {
    closePopover();
    onEditFlag(flag);
  };

  return (
    <Popover
      content={
        <Card padding="md" radius="md">
          <Box borderWidth="0" shadow="0">
            {!shouldHide && (
              <Button variant="tertiary" tone="neutral" fullWidth iconPrefix="add" onClick={handleAddNewFlagClick}>
                Add New Flag
              </Button>
            )}

            {flags?.map((flag, i) => {
              const displayReason =
                flag?.reason ||
                (flag?.problems?.length &&
                  setting?.acceptanceCriteria?.find((criterion: any) => {
                    const criterionId = flag?.problems && flag?.problems[0]?.acceptanceCriteriaId.toString();
                    return criterion?.id?.toString() === criterionId;
                  })?.displayText) ||
                dataKey;
              return (
                <Box
                  key={i}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  cursor="pointer"
                  padding="xs"
                  background="primary"
                  radius="md"
                  hover={{
                    background: 'tertiary',
                  }}
                  onClick={() => handleEditFlagClick(flag)}
                >
                  <Box as="h3" fontWeight="medium" fontSize="md">
                    {displayReason}
                  </Box>
                  <Icon size="md" name="caret-right" />
                </Box>
              );
            })}
          </Box>
        </Card>
      }
      isOpen={isPopoverOpen}
      placement="bottom"
      onClickOutside={closePopover}
      hasArrow={false}
      contentContainerProps={{
        padding: '0',
        background: 'white',
        width: '25',
        radius: 'md',
        color: 'body-primary',
      }}
    >
      <Box onClick={handleButtonClick}>{children}</Box>
    </Popover>
  );
};
